import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AbstractCallComponent } from '../abstract-call/abstract-call.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EExternalIntegrationCallType, EHttpMethod, Json } from '../../tp-integrations.interface';
import { firstValueFrom, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { fetchPost } from '../../routines';

@Component({
    selector: 'se-rest-call',
    templateUrl: './rest-call.component.html',
    styleUrls: ['../call-style/call.scss'],
})
export class RestCallComponent extends AbstractCallComponent implements OnInit, AfterViewInit {
    url: string | null = null;
    body: Json | null = null;

    constructor(private http: HttpClient) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
        this.parsePropsWithData();
        this.callInit();
    }

    getEstensaBaseUrl(): string {
        return Reflect.get(window, 'restServiceBaseUrl') ?? location.origin;
    }

    getEstensaToken(): string {
        return localStorage.getItem('access_token') || '';
    }

    createHeaders = (): null | HttpHeaders => {
        const isEstensa = this.call.type === EExternalIntegrationCallType.REST_ESTENSA;
        const callHeaders = this.call.headers;
        if (!isEstensa && !callHeaders) return null;
        let headersObj: Record<string, string>;
        const parsedProps = this.parseAllSourceWithDataStore(this.call);
        headersObj = parsedProps.headers || {};

        if (isEstensa) {
            /*@TODO chiedere se dare la precedenza alla configurazione impostata a mano oppure al settaggio REST_ESTENSA*/
            //const token = this.getEstensaToken();
            // headersObj.Authorization = `Bearer ${token}`;
            headersObj['Content-Type'] = 'application/json';
            headersObj.Accept = 'application/json,text/plain,*/*';
        }
        return new HttpHeaders(headersObj);
    };

    parsePropsWithData = () => {
        let url: string = '';
        if (this.dataStore) {
            const parsedStrings = this.parseAllSourceWithDataStore(this.call);
            url = parsedStrings.url ?? '';
            this.body = parsedStrings.body ?? null;
        } else {
            url = this.call.url ?? '';
            this.body =
                this.call.body && typeof this.call.body === 'string' ? JSON.parse(this.call.body) : this.call.body;
        }

        if (this.call.type === EExternalIntegrationCallType.REST_ESTENSA) {
            url = `${this.getEstensaBaseUrl()}/${url}`;
        }

        this.url = url;
    };

    async httpGet() {
        if (!this.url) {
            return this.end();
        }

        const headers = this.createHeaders();

        return firstValueFrom(
            this.http.get(this.url, headers ? { headers } : undefined).pipe(
                catchError((err) => {
                    this.callThrowError.emit(err.message ?? this.call.errorHandling?.message ?? 'GenericRestError');
                    return throwError(() => err);
                }),
            ),
        );
    }

    httpPost = async () => {

        if (!this.url) {
            return this.end();
        }

        if (this.call.test) {
            return fetchPost<any>(this.call.url || this.url, JSON.stringify(this.body));
        }

        const headers = this.createHeaders();

        return firstValueFrom(
            this.http.post(this.url, this.body, headers ? { headers } : undefined).pipe(
                catchError((err) => {
                    this.callThrowError.emit(err.message ?? this.call.errorHandling?.message ?? 'GenericRestError');
                    return throwError(() => err);
                }),
            ),
        );
    };

    ngAfterViewInit(): void {
        if (!!this.url) this.showLoading = true;
    }

    protected async run(): Promise<any> {
        switch (this.call.httpMethod) {
            case EHttpMethod.POST:
                return this.httpPost();
            case EHttpMethod.GET:
            default:
                return this.httpGet();
        }
    }

    protected end() {
        /*gestione errorHandling* */
        const path = this.call.errorHandling?.path || '';
        let value;
        //usare isPrimitiveType() ?
        if (typeof this.result !== 'object' && !Array.isArray(this.result)) value = this.result;
        else {
            value =
                this.result && this.result[path] !== undefined
                    ? this.result[path]
                    : path.split('.').reduce((agg: { [x: string]: any }, curr: string | number) => {
                        return agg && agg[curr];
                    }, this.result);
        }

        if (this.errorValueHandler(value)) {
            this.callThrowError.emit(this.call.errorHandling?.message ?? 'GenericRestError');
        } else {
            super.end();
        }
    }
}
